import { css, unsafeCSS } from 'lit';
const defaultConfig = {
    sceneBackgroundColor: 'var(--color-background-bg-primary)',
};
export const sceneStyle = (config) => {
    const _config = { ...defaultConfig, ...config };
    return css `
    :host {
      display: flex;
      --scene-background-color: ${unsafeCSS(_config.sceneBackgroundColor)};
    }

    .scene-container {
      min-height: 50px;
      min-width: 50px;
      height: 100%;
      position: relative;
      overflow: hidden;
      border-radius: 16px;
      will-change: width, height, transform, filter;
    }
  `;
};
//# sourceMappingURL=scene.style.js.map